import { z } from 'zod';

import { Time_Period, Time_Since_Last_Visit_Operator } from '@occc/graphql';
import {
  lastVisitOperatorsOptions,
  lastVisitTimePeriodOptions,
} from '@occc-app/routes/Audience/components/FuelAndConvenienceProfile/constants';
import { Paths } from 'type-fest';
import { LastVisitValues } from './types';
import { LAST_VISIT_MAX_BY_PERIOD } from './constants';
import { addCustomIssue as addIssue } from '../../utils';

const operatorOptions = lastVisitOperatorsOptions.map(({ value }) => value) as [
  Time_Since_Last_Visit_Operator,
  ...Time_Since_Last_Visit_Operator[],
];

const periodOptions = lastVisitTimePeriodOptions.map(({ value }) => value) as [
  Time_Period,
  ...Time_Period[],
];

export const lastVisitSchema = z
  .object({
    operator: z.union([z.enum(operatorOptions), z.literal('')]).optional(),
    amount: z.number().min(0).nullable().optional(),
    period: z.union([z.enum(periodOptions), z.literal('')]).optional(),
  })
  .superRefine((values, ctx) => {
    const { operator, amount, period } = values;
    const isAmount = typeof amount === 'number';
    const isAnyFieldFilled = !!operator || isAmount || !!period;
    const isAllFilled = !!operator && isAmount && !!period;

    if (!isAnyFieldFilled) return;

    if (!isAllFilled) {
      if (!operator) addIssue(ctx, 'operator' satisfies Paths<LastVisitValues>);
      if (!isAmount) addIssue(ctx, 'amount' satisfies Paths<LastVisitValues>);
      if (!period) addIssue(ctx, 'period' satisfies Paths<LastVisitValues>);
    }

    if (!isAmount || !period) return;

    const { max, errorMessage } = LAST_VISIT_MAX_BY_PERIOD[period];
    if (amount > max) {
      addIssue(ctx, 'amount' satisfies Paths<LastVisitValues>, errorMessage);
    }
  })
  .optional();
